// extracted by mini-css-extract-plugin
export var fadeIn = "_hf-1";
export var modalContent = "_hf-3";
export var overlay = "_hf-0";
export var popoverContent = "_hf-2";
export var results = "_hf-5";
export var searchInputWrapper = "_hf-4";